<ion-header>
  <!-- <div class="PropertyWorkflowModal__HeaderRow row">
      <div class="col"> -->
  <ion-toolbar color="primary">
    <ion-title [innerHTML]="modalTitle"></ion-title>
  </ion-toolbar>
</ion-header>
<!-- Form Row -->
<ion-content>
  <div class="container">
    <div class="PropertyWorkflowModal__FormRow row">
      <div class="col">
        <form [formGroup]="updateForm">
          @for (field of fieldList; track field) {
            <div class="PropertyWorkflowModal__FormField">
              <ng-container dynamicField [field]="field" [group]="updateForm">
              </ng-container>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        class="PropertyWorkflowModal__Button"
        fill="outline"
        (click)="cancel()"
        [innerHTML]="'Cancel'"
      ></ion-button>
      <ion-button
        class="PropertyWorkflowModal__Button"
        fill="solid"
        color="primary"
        (click)="save()"
        [innerHTML]="'Proceed'"
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
